<template>
    <div class="schedule">
        <span :class="['number', props.step > 0 ? 'active' : '']">
            <iconpark-icon name="chenggong" v-if="props.step > 1"></iconpark-icon>
            <b v-else>1</b>
            <span>实名方式</span>
        </span>
        <span class="spot">·····</span>
        <span :class="['number', props.step > 1 ? 'active' : '']">
            <iconpark-icon name="chenggong" v-if="props.step > 2"></iconpark-icon>
            <b v-else>2</b>
            <span>实名认证</span>
        </span>
        <span class="spot">·····</span>
        <span v-if="type == 1" :class="['number', props.step > 2 ? 'active' : '']">
            <iconpark-icon name="chenggong" v-if="props.step > 3"></iconpark-icon>
            <b v-else>3</b>
            <span>认证审核</span>
        </span>
        <span v-else :class="['number', props.step > 2 ? 'active2' : '']">
            <iconpark-icon name="chenggong" v-if="props.step >= 3"></iconpark-icon>
            <b v-else>3</b>
            <span>认证成功</span>
        </span>
        <template v-if="type == 1">
            <span class="spot">·····</span>
            <span :class="['number', props.step > 3 ? 'active2' : '']">
                <iconpark-icon name="chenggong" v-if="props.step >= 4"></iconpark-icon>
                <b v-else>4</b>
                <span>认证成功</span>
            </span>
        </template>
    </div>

</template>
<script setup>
const props = defineProps({
    type: {
        default: 0
    },
    step: {
        default: 1
    }
})

</script>
<style lang="scss" scoped>
.schedule {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30rem 0;

    .number {
        display: inline-block;
        width: 55rem;
        height: 55rem;
        line-height: 40rem;
        text-align: center;
        color: #A6A6A6;
        font-size: 36rem;
        border: 2rem solid #A6A6A6;
        border-radius: 45rem;
        position: relative;

        span {
            display: block;
            position: absolute;
            bottom: -35rem;
            left: -27.5rem;
            font-size: 12rem;
            width: 105rem;
            text-align: center;
        }

        b {
            font-weight: normal;
            font-size: 24rem;
        }

        iconpark-icon {
            font-size: 30rem;
            color: #FFF;
            transform: translateY(5rem);
        }
    }

    .active {
        background-color: #0A84FF;
        border-color: #0A84FF;
        color: #FFF;

        span {
            color: #0A84FF;
        }
    }
    .active2{
        background-color: rgba(67, 207, 124, 1);
        border-color: rgba(67, 207, 124, 1);
        color: #FFF;

        span {
            color: rgba(67, 207, 124, 1);
        }
    }

    .spot {
        font-weight: bold;
        font-size: 10rem;
        color: #A6A6A6;
    }
}
</style>